import { v4 as uuidv4 } from 'uuid';
import { getIdToken } from '../authUtils';
import { ApiError } from '../errors';

export const API_NAME = 'loyalty-admin-portal-api';
export const MULE_API_NAME = 'mulesoft-api-url';
export const MULE_CLIENT_ID = process.env.REACT_APP_MULE_CLIENT_ID;
export const MULE_CLIENT_SECRET = process.env.REACT_APP_MULE_CLIENT_SECRET;

export const getConfig = async (body = undefined) => {
    return {
        headers: {
            Authorization: await getIdToken(),
            'X-Correlation-Id': uuidv4(),
            'X-Channel': 'WEBSITE',
        },
        body,
    };
};
export const validateResponse = (resp) => {
    return resp;
};
export const handleError = (err) => {
    throw new ApiError(err);
};

export const getMuleConfig = async (body = undefined) => {
    return {
        headers: {
            client_id: MULE_CLIENT_ID,
            client_secret: MULE_CLIENT_SECRET,
            'X-Correlation-Id': uuidv4(),
            'X-Channel': 'LOYALTY',
        },
        body,
    };
};
